module.exports = __webpack_public_path__ + "static/media/assignment.65467512.svg";